import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchAllKomisi } from "redux/features/komisi";
import { capitalize } from "lodash";
import { message } from "antd";

export const useKomisi = () => {
  const [komisi, setKomisi] = useState([]);
  const dispatch = useDispatch();

  const getKomisi = async () => {
    try {
      const res = await dispatch(fetchAllKomisi()).unwrap();
      console.log("resHook:", res.data);
      setKomisi(
        res.data.map((item) => {
          return {
            label: `${item.nomor} - ${item.description}`,
            value: item.id,
          };
        })
      );
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  useEffect(() => {
    getKomisi();
  }, []); // -> deps = [] ini buat jalan sekali saat pertama render

  return { komisi };
};
